import { Buttom } from "components/buttom/buttom"
import { useEffect, useState } from "react"
import { AddEditManagerModal } from "./Add-Edit"
import { Table, Button, Pagination } from "react-bootstrap"
import { FaEdit, FaTrash, FaSortUp, FaSortDown } from "react-icons/fa"
import { ErrorAlert } from "components/alerts/ErrorAlert"
import { deleteNotice, getNotices } from "services/managerNotices/managerNotices"
import { QuestionAlert } from "components/alerts/Question"
import { Loading } from "components/loading/loading"
import { LoadingAlert } from "components/alerts/LoadingAlert"
import { SuccessAlert } from "components/alerts/Success"
import dayjs from "dayjs"

export const ManageNotices = () => {
  const [notices, setNotices] = useState<any>([])
  const [showModalAddEditManager, setShowModalAddEditManager] = useState(false)
  const [loading] = useState(false)
  const [objectToEdit, setObjectToEdit] = useState<{
    objectId: string
    tipo: string
    mensagem: string
  } | undefined>()
  const [currentPage, setCurrentPage] = useState(1)
  const itemsPerPage = 10

  const [sortConfig, setSortConfig] = useState<{ key: string; direction: "asc" | "desc" } | null>(null)

  const handleSort = (key: string) => {
    let direction: "asc" | "desc" = "asc"
    if (sortConfig && sortConfig.key === key && sortConfig.direction === "asc") {
      direction = "desc"
    }
    setSortConfig({ key, direction })
  }

  const sortedNotices = (() => {
    const sortable = [...notices]
    if (sortConfig) {
      sortable.sort((a, b) => {
        let aVal = a[sortConfig.key]
        let bVal = b[sortConfig.key]

        // Se for data, transformar em Date para comparar
        if (sortConfig.key === "dataExpiracao") {
          aVal = new Date(aVal)
          bVal = new Date(bVal)
        }

        if (aVal < bVal) return sortConfig.direction === "asc" ? -1 : 1
        if (aVal > bVal) return sortConfig.direction === "asc" ? 1 : -1
        return 0
      })
    }
    return sortable
  })()

  const indexOfLastItem = currentPage * itemsPerPage
  const indexOfFirstItem = indexOfLastItem - itemsPerPage
  const currentNotices = sortedNotices.slice(indexOfFirstItem, indexOfLastItem)

  const totalPages = Math.ceil(notices.length / itemsPerPage)

  const handlePageChange = (pageNumber: number) => setCurrentPage(pageNumber)

  const getNoticesToTable = async () => {
    try {
      const notices = await getNotices()
      setNotices(notices)
    } catch (error: any) {
      ErrorAlert({ message: error.response.data.message })
    }
  }

  useEffect(() => {
    LoadingAlert({ show: true })
    getNoticesToTable()
    LoadingAlert({ show: false })
  }, [])

  const handleEdit = (notice: any) => {
    setObjectToEdit(notice)
    setShowModalAddEditManager(true)
  }

  const handleDelete = async (objectId: string) => {
    const confirm = await QuestionAlert({ text: "Deseja excluir esse aviso?" })
    if (!confirm) return
    try {
      LoadingAlert({ show: true })
      const response = await deleteNotice(objectId)
      LoadingAlert({ show: false })

      if (response) {
        SuccessAlert({ message: "Aviso excluido com sucesso" })
        getNoticesToTable()
      }
    } catch (error: any) {
      ErrorAlert({ message: error.response.data.message })
    }
  }

  const renderSortIcon = (key: string) => {
    if (!sortConfig || sortConfig.key !== key) return null
    return sortConfig.direction === "asc" ? (
      <FaSortUp className="ms-1" />
    ) : (
      <FaSortDown className="ms-1" />
    )
  }

  return (
    <>
      <div className='container mt-4'>
        <div className='row justify-content-center'>
          <div className='col-12 text-center'>
            <h1>Gerenciar avisos</h1>
          </div>
        </div>

        <div className='row justify-content-center mb-3'>
          <Buttom
            text='Adicionar aviso'
            id='btn-reload'
            onClick={() => setShowModalAddEditManager(true)}
            disabled={false}
            color='#30a151'
          />
          {showModalAddEditManager && <AddEditManagerModal
            object={objectToEdit as {
              objectId: string
              tipo: "AVISO" | "ALERTA" | "COMUNICADO" | "PROMOÇÃO" | ""
              mensagem: string
              dataExpiracao: dayjs.Dayjs
            }}
            show={showModalAddEditManager}
            onHide={() => {
              setShowModalAddEditManager(false)
              getNoticesToTable()
              setObjectToEdit(undefined)
            }}
          />}
        </div>
        {loading ? (
          <Loading />
        ) :

          <div className='row'>
            <div className='col-12'>
              <Table striped bordered hover responsive>
                <thead>
                  <tr>
                    <th  onClick={() => handleSort("dataExpiracao")} style={{ cursor: "pointer" }}>
                      Data {renderSortIcon("dataExpiracao")}
                    </th>
                    <th  onClick={() => handleSort("tipo")} style={{ cursor: "pointer" }}>
                      Tipo {renderSortIcon("tipo")}
                    </th>
                    <th onClick={() => handleSort("mensagem")} style={{ cursor: "pointer" }}>
                      Mensagem {renderSortIcon("mensagem")}
                    </th>
                    <th onClick={() => handleSort("expirado")} style={{ cursor: "pointer" }}>
                      Expirado {renderSortIcon("expirado")}
                    </th>
                    <th >Ações</th>
                  </tr>
                </thead>
                <tbody>
                  {notices.length === 0 && <tr><td colSpan={5}>Nenhum aviso cadastrado</td></tr>}
                  {currentNotices.map((notice: any) => (
                    <tr key={notice.objectId}>
                      <td style={{ textAlign: "center", width: "10%", alignContent: "center" }}>
                        {new Date(notice.dataExpiracao).toLocaleDateString("pt-BR")}
                      </td>
                      <td style={{ textAlign: "center", width: "10%", alignContent: "center" }}>{notice.tipo}</td>
                      <td style={{ textAlign: "center", width: "50%" , alignContent: "center"}}>
                        <div style={{ alignContent: "center"}} dangerouslySetInnerHTML={{ __html: notice.mensagem }} />
                      </td>
                      <td style={{ textAlign: "center", width: "10%", alignContent: "center" }}>{notice.expirado ? "SIM" : "NÃO"}</td>
                      <td style={{ textAlign: "center", width: "20%", alignContent: "center" }}>
                        <Button
                          style={{ marginRight: "5px" }}
                          variant='success'
                          size='sm'
                          onClick={() => handleEdit(notice)}
                        >
                          <FaEdit />
                        </Button>

                        <Button
                          variant='danger'
                          size='sm'
                          onClick={() => handleDelete(notice.objectId)}
                        >
                          <FaTrash />
                        </Button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
              <div className='d-flex justify-content-center'>
                <Pagination size="sm">
                  {Array.from({ length: totalPages }, (_, idx) => {
                    const isActive = currentPage === idx + 1
                    return (
                      <Pagination.Item
                        activeLabel=""
                        key={idx + 1}
                        active={isActive}
                        onClick={() => handlePageChange(idx + 1)}
                        linkStyle={{
                          color: "black",
                          backgroundColor: isActive ? "#30a151" : "white",
                          border: "none"
                        }}
                      >
                        <span aria-hidden="true">{idx + 1}</span>
                      </Pagination.Item>
                    )
                  })}
                </Pagination>
              </div>
            </div>
          </div>
        }
      </div >
    </>
  )
}
